import React from "react";
import { Carousel } from "react-bootstrap";
import { motion } from "framer-motion";
import "./carousel.css";

const Maincarousel = () => {
  return (
    <div>
      <motion.div
        className="hero-carousel"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Carousel fade interval={3000} pause={false} indicators controls>
          {/* Slide 1 */}
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="./images/carousel-1.webp"
              alt="Slide 1"
            />
            {/* <Carousel.Caption>
              <motion.h2
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.3 }}
              >
                Latest Apple Products
              </motion.h2>
              <p>Premium quality. Best prices.</p>
            </Carousel.Caption> */}
          </Carousel.Item>

          {/* Slide 2 */}
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="./images/carousel-2.webp"
              alt="Slide 2"
            />
            {/* <Carousel.Caption>
              <motion.h2
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 0.3 }}
              >
                Big Sale Up To 50% Off
              </motion.h2>
              <p>Limited time offer</p>
            </Carousel.Caption> */}
          </Carousel.Item>

          {/* Slide 3 */}
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="./images/carousel-3.webp"
              alt="Slide 3"
            />
            {/* <Carousel.Caption>
              <motion.h2
                initial={{ x: -40, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.3 }}
              >
                Free Shipping Worldwide
              </motion.h2>
              <p>Fast & secure delivery</p>
            </Carousel.Caption> */}
          </Carousel.Item>
        </Carousel>
      </motion.div>
    </div>
  );
};

export default Maincarousel;
